export const formattedMoney = (
  price: string,
  locale: string,
  currency: string
) => {
  const priceNum = Number(price.replace('$', '').replace(',', ''))

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  })
    .format(priceNum)
    .replace('R', '')
}

export const capitalize = (word: string, mode: string) => {
  const untreatedString = word?.replaceAll('-', ' ')
  const treatedString = untreatedString.split(' ')

  if (mode === 'breadcrumb') {
    const capitalizedStrings = treatedString.map((item) => {
      return item.charAt(0).toUpperCase() + item.slice(1)
    })

    return capitalizedStrings.join(' ')
  }

  return treatedString[0].charAt(0).toUpperCase() + treatedString[0].slice(1)
}

export const normalizeTitle = (phrase?: string): string => {
  if (!phrase) {
    return ''
  }

  const cleaned = phrase.toLowerCase().replace(/-/g, ' ')

  const words = cleaned
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))

  return words.join(' ')
}

export const formatCategoriesForEvent = (categories: string) => {
  if (categories === undefined) {
    return ''
  }

  return categories.split('/').slice(1, -1).join(' > ')
}
